// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import Color from "color";
import LocalShipping from "elevate-ui-icons/LocalShipping";
import MonetizationOn from "elevate-ui-icons/MonetizationOn";
import AssignmentTurnedIn from "elevate-ui-icons/AssignmentTurnedIn";
import SmsFailed from "elevate-ui-icons/SmsFailed";

type $Props = {
  classes: Object,
  page: string,
};

const Links = ({ classes, page }: $Props) => (
  <div className={classes.root}>
    <a
      className={classNames({
        [classes.link]: true,
        [classes.active]: page === "tips" || page === "tips/moving",
      })}
      href={"/tips/moving"}
    >
      <LocalShipping size={16} />{" "}
      <span className={classes.linkText}>Moving Tips</span>
    </a>
    <a
      className={classNames({
        [classes.link]: true,
        [classes.active]: page === "tips/buying",
      })}
      href="/tips/buying"
    >
      <MonetizationOn size={16} />{" "}
      <span className={classes.linkText}>Home Buying Tips</span>
    </a>
    <a
      className={classNames({
        [classes.link]: true,
        [classes.active]: page === "tips/selling",
      })}
      href="/tips/selling"
    >
      <AssignmentTurnedIn size={16} />{" "}
      <span className={classes.linkText}>Home Selling Tips</span>
    </a>
    <a
      className={classNames({
        [classes.link]: true,
        [classes.active]: page === "tips/mistakes",
      })}
      href="/tips/mistakes"
    >
      <SmsFailed size={16} />{" "}
      <span className={classes.linkText}>Mistakes Sellers Make</span>
    </a>
  </div>
);

const styles = (theme) => {
  const primaryFontColor = Color(theme.colors.primary["500"]).isDark()
    ? theme.colors.primary["500"]
    : theme.colors.gray["900"];
  return {
    root: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      placeItems: "center",
      width: "100%",
      margin: "48px 0 36px",
      borderRadius: theme.globalBorderRadius,
      overflow: "hidden",
      border: `1px solid ${theme.colors.gray["300"]}`,
      "& a": {
        borderTop: `1px solid ${theme.colors.gray["300"]}`,
      },

      "& a:first-child": {
        borderTop: "none",
        borderTopLeftRadius: theme.globalBorderRadius,
      },

      "& a:nth-child(2)": {
        borderTop: "none",
        borderTopRightRadius: theme.globalBorderRadius,
        borderLeft: `1px solid ${theme.colors.gray["300"]}`,
      },

      "& a:nth-child(3)": {
        borderBottomLeftRadius: theme.globalBorderRadius,
      },

      "& a:last-child": {
        borderBottomRightRadius: theme.globalBorderRadius,
        borderLeft: `1px solid ${theme.colors.gray["300"]}`,
      },

      [theme.breakpoints(800)]: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        placeItems: "center",

        "& a": {
          borderLeft: `1px solid ${theme.colors.gray["300"]}`,
          borderTop: "none",
        },

        "& a:first-child": {
          borderLeft: "none",
          borderBottomLeftRadius: theme.globalBorderRadius,
        },

        "& a:nth-child(2)": {
          borderTopRightRadius: "0px",
        },

        "& a:nth-child(3)": {
          borderBottomLeftRadius: "0px",
        },

        "& a:last-child": {
          borderTopRightRadius: theme.globalBorderRadius,
          borderBottomRightRadius: theme.globalBorderRadius,
        },
      },

      ".ie-11 &": {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "flex-start",
        flexFlow: "row wrap",
      },
    },
    link: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flex: "2 1 50%",
      width: "100%",
      height: "100%",
      padding: theme.spacing.unit,
      backgroundColor: "#fff",
      color: theme.colors.gray["700"],
      fontWeight: "600",
      fontSize: "13px",
      textAlign: "center",
      lineHeight: "1.3",
      textDecoration: "none",

      [theme.breakpoints(800)]: {
        display: "flex",
        flexDirection: "row",
        flex: "1",
      },

      "&:hover": {
        color: theme.colors.gray["700"],
        textDecoration: "none",
        cursor: "pointer",
      },
      "&:focus": {
        color: theme.colors.gray["700"],
        textDecoration: "none",
        outline: "none",
      },
    },
    linkText: {
      marginTop: theme.spacing.unit * 0.25,

      [theme.breakpoints(800)]: {
        marginLeft: theme.spacing.unit * 0.25,
        marginTop: "0px",
      },
    },
    active: {
      backgroundColor: theme.colors.gray["100"],
      color: primaryFontColor,

      "&:hover": {
        color: primaryFontColor,
      },
    },
  };
};

export default withStyles(styles)(Links);
